<template>
  <v-container
    id="data-management"
    tag="section"
  >
    <base-resource-grid
      ref="resourceGrid"
      color="blue-grey"
      icon="mdi-textbox-password"
      plural-name="Templates"
      singular-name="Template"
      allow-expand
      fullscreen-edit
      :headers="productTemplateHeaders"
      :resource="productTemplateResource"
      :actions="actions"
      @handleAction="handleAction"
    >
      <template v-slot:editForm="editForm">
        <v-row>
          <v-col
            cols="12"
          >
            <product-template-wizard
              :edited-item="editForm.editedItem"
              @producttemplate:saved="productTemplateSaved"
              @wizard:finished="closeEditDialog"
              @producttemplate:changed="productTemplateChanged"
            />
          </v-col>
        </v-row>
      </template>
      <template v-slot:actionButtons>
        <v-card-actions>
          <v-spacer />
        </v-card-actions>
      </template>
    </base-resource-grid>
    <base-history-dialog
      id-field="productTemplateId"
      title-field="productTemplate"
      color="blue-grey"
      :resource-endpoint="historyEndpoint"
      :columns="historyHeaders"
      :item="historyItem"
      @hide="historyItem = null"
    >
      <template v-slot:header>
        <v-card>
          <v-tabs
            background-color="blue-grey accent-4"
            center-active
            center
          >
            <v-tab
              @click="setHistoryTab('productTemplate')"
            >
              Templates
            </v-tab>
          </v-tabs>
        </v-card>
      </template>
    </base-history-dialog>
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'

  export default {
    name: 'ProductTemplates',

    components: {
      ProductTemplateWizard: () => import('./components/ProductTemplateWizard'),
    },

    data: () => ({
      historyTab: 'productTemplate',

      productTemplateHeaders: [
        {
          text: 'Type',
          value: 'productType',
        },
        {
          text: 'Template',
          value: 'productTemplateType',
        },
        {
          text: 'Product',
          value: 'product',
        },
        {
          text: 'Carrier',
          value: 'carrier',
        },
        {
          text: 'Platform',
          value: 'platform',
        },
      ],

      actions: [
        {
          color: 'info',
          icon: 'mdi-information-variant',
          action: 'history',
        },
      ],

      productTemplateResource: new TroodyApi('productTemplate/'),

      historyItem: null,
    }),

    computed: {
      historyHeaders () {
        let output = this.productTemplateHeaders
        switch (this.historyTab) {
          case 'productTemplate':
            output = this.productTemplateHeaders
            break
          default:
            output = this.productTemplateHeaders
            break
        }
        return output
      },

      historyEndpoint () {
        let output = 'productTemplateHistory/'
        switch (this.historyTab) {
          case 'productTemplate':
            output = 'productTemplateHistory/'
            break
          default:
            output = 'productTemplateHistory/'
            break
        }
        return output
      },
    },

    methods: {
      handleAction (action, data) {
        if (action === 'history') {
          this.historyItem = data
        }
      },

      closeEditDialog () {
        this.$refs.resourceGrid.close()
      },

      productTemplateSaved (data) {
        this.$refs.resourceGrid.itemEdited(data)
      },

      productTemplateChanged (data) {
        console.log('productTemplateChanged')
        console.log(data)
      },
    },
  }
</script>
